<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div *ngIf="mode != 'author'" class="avatar">
          <ngx-view-user-display
            [user]="qna.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <div (click)="onClick()" class="link text-heading">
            {{ qna.title }}
          </div>
          <div (click)="onClick()" class="link text-hint">
            {{
              qna.description.length < 100
                ? qna.description
                : qna.description.substring(0, 100) + "..."
            }}
          </div>
        </div>
      </div>
    </div>
  </nb-card-header>

  <nb-card-footer>
    <nb-actions class="button-actions">
      <nb-action>
        <nb-icon class="action-icon" icon="like" pack="liked-icon"></nb-icon>
        <span>{{ qna.noLiked ? qna.noLiked : "." }}</span>
      </nb-action>

      <!-- <nb-action>
        <nb-icon status="success" icon="eye-outline"></nb-icon>
        <span>{{ qna.noViewer ? qna.noViewer : "." }}</span>
      </nb-action> -->

      <nb-action>
        <nb-icon icon="message-square-outline"></nb-icon>
        <span>{{ qna.noReply ? qna.noReply : "." }}</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
